import styled from 'styled-components';
import { Drawer as DrawerAtom } from 'components/atoms/drawer';
export const Drawer = styled(DrawerAtom).attrs({
    width: 920,
    closable: true,
    placement: 'left',
    destroyOnClose: true
})`
  left: 48px;
  z-index: var(--zindex-popover-low);
  .ant-drawer-header {
    padding: var(--spacing-05) var(--spacing-06);
  }
  .ant-drawer-body {
    padding: 0;
  }
`;
